import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { Router, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';

/**
 * LoginDialogComponent
 */
@Component({
  selector: 'ecp-login-dialog',
  templateUrl: './login-dialog.component.html',
  styleUrls: ['./login-dialog.component.scss'],
  standalone: false,
})
export class LoginDialogComponent implements OnInit, OnDestroy {
  /**
   * subscription
   */
  subscription: Subscription;

  /**
   * constructor
   * @param {MatDialogRef<LoginDialogComponent>} dialogRef
   * @param {Router} router
   * @param data
   */
  constructor(
    public dialogRef: MatDialogRef<LoginDialogComponent>,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    this.subscription = this.router.events.pipe(filter((event) => event instanceof NavigationStart)).subscribe(() => {
      this.dialogRef.close();
    });
  }

  /**
   * ngOnDestroy
   */
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
